import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import useTheme from "@mui/material/styles/useTheme";

import { neutral } from "app/themes/colors";

import useSunoDialer from "../use-suno-dialer.hook";
import CallItemsContainer from "./call-items-container/call-items-container.component";

export default function QueueWidget() {
  const theme = useTheme();
  const {
    callsQueue: { ids },
    displaySettings: { showQueue },
    handleToggleShowQueue
  } = useSunoDialer();

  if (!ids.length) return null;
  return (
    <Box sx={{ pt: 1 }}>
      <Stack
        sx={{
          opacity: ids.length ? 1 : 0,
          color: "white",
          background: "rgba(57,68,64,0.9)",
          px: 1.5,
          pt: 0.75,
          pb: 0.75,
          borderRadius: "8px",
          boxShadow: theme.shadows[3],
          cursor: "pointer",
          "&:hover": {
            background: !showQueue ? neutral[800] : undefined
          }
        }}
        onClick={handleToggleShowQueue}
      >
        <Stack
          direction="row"
          justifyContent="flex-between"
          width="100%"
          alignItems="center"
        >
          <Stack width="100%" height="100%" spacing={0.25} pr={2}>
            <Typography
              sx={{
                fontSize: "15px",
                lineHeight: 1.3
              }}
            >
              Calls in Queue{" "}
              <Badge
                color="primary"
                badgeContent={ids.length}
                sx={{ ml: 2, mt: -0.25 }}
              />
            </Typography>
          </Stack>
          <Stack maxWidth="80px">
            <IconButton
              size="small"
              sx={{
                p: 0,
                transform: "scale(0.9)",

                color: "white"
              }}
            >
              {showQueue ? <UnfoldLessIcon /> : <UnfoldMoreIcon />}
            </IconButton>
          </Stack>
        </Stack>

        {showQueue ? <CallItemsContainer /> : null}
      </Stack>
    </Box>
  );
}
